module.exports = __webpack_public_path__ + "img/hometeacher.0f8e8e01.png";